import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import Tooltip from 'rc-tooltip';
import React, { Component } from 'react';
import { Link } from 'react-router';

export default class NavIcon extends Component {
  static propTypes = {
    title: PropTypes.string,
    linkTarget: PropTypes.string,
    iconClass: PropTypes.string,
    customIcon: PropTypes.string,
    selected: PropTypes.bool,
  };

  state = {
    disableTooltip: false,
    tooltipIsVisible: false,
  };

  handleVisibleChange = isVisible => {
    this.setState({
      tooltipIsVisible: !this.state.disableTooltip && isVisible,
    });
  };

  handleDisableTooltip = () => {
    this.setState({
      disableTooltip: true,
      tooltipIsVisible: false,
    });
  };

  handleEnableTooltip = () => {
    this.setState({
      disableTooltip: false,
      tooltipIsVisible: true,
    });
  };

  setProductInSession = () => {
    const { product } = this.props;

    if (product) sessionStorage.setItem('product', product);
  }

  render() {
    // TODO: Override visible is a temporary fix to hide tooltips on changing products for staging push - undo after issues is live
    const { title, linkTarget, icon, selected, overrideVisible } = this.props;
    const { tooltipIsVisible } = this.state;

    return (
      <div
        style={{
          background: selected ? '#0e4151' : null,
          cursor: 'pointer',
        }}
      >
        <Tooltip
          placement="right"
          overlay={title}
          onVisibleChange={this.handleVisibleChange}
          visible={overrideVisible ? false : tooltipIsVisible}
        >
          {title === 'Help' ? (
            <a
              href={linkTarget}
              disabled={linkTarget ? false : true}
              target="_blank"
              rel="noopener noreferrer"
              data-test={title}
            >
              <FontAwesomeIcon
                className={`fa-style ${selected ? 'active' : ''}`}
                size="lg"
                icon={icon}
              />
            </a>
          ) : (
            <div>
              {this.props.children ? (
                React.cloneElement(this.props.children, {
                  disableTooltip: this.handleDisableTooltip,
                  enableTooltip: this.handleEnableTooltip,
                })
              ) : (
                <Link to={linkTarget} onClick={this.setProductInSession} disabled={linkTarget ? false : true} data-test={title}>
                  <FontAwesomeIcon
                    className={`fa-style ${selected ? 'active' : ''}`}
                    size="lg"
                    icon={icon}
                  />
                </Link>
              )}
            </div>
          )}
        </Tooltip>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/toolbars/IconNavList/industry/construction/NavIcon.js